export const API_URL = "https://api.mandarin.weniv.co.kr";
